import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import AppBar from '@material-ui/core/AppBar';
import { withStyles } from '@material-ui/core';
import logo from '../images/logo.png'; 
import SideDrawer from './sideDrawer/SideDrawer';
import ChangeLangaugeMenu from './ChangeLanguageMenu';


const styles = {
    root: {
        background: 'transparent',
        boxShadow: 'none',
        padding: '10',
      },
    menuButton: {
        marginLeft: 'auto',
        //alignItems: 'right',
    },
  };

  
class PrimaryAppBar extends Component{

    state = {
        right: false,
    };

    toggleDrawer = (side, open) => () => {
        this.setState({
          [side]: open,
        });
    };

    render(){
        const { classes } = this.props;
        return(
            <div>
                <AppBar position="sticky" className={classes.root}>
                    <Toolbar style={{padding: '0', display: 'flex', justifyContent: 'center',}}>
                        <img src={logo} />
                        <IconButton
                            className={classes.menuButton}
                            color="inherit"
                            aria-label="Menu"
                            onClick={this.toggleDrawer('right', true)}
                        >
                                <MenuIcon style={{color: '#B71C1C'}}/>
                        </IconButton>
                    </Toolbar>
                    {/* <ChangeLangaugeMenu /> */}
                </AppBar>
                <SideDrawer openDrawer={this.state.right} toggleDrawer={this.toggleDrawer}/>
            </div>

        );
    }
}

export default withStyles(styles)(PrimaryAppBar);